import { type Enum } from '../../utils/enums'

export const ExportStatuses = {
  PROCESSING: 0,
  COMPLETED: 1,
  ERROR: 2,
} as const

export type ExportStatus = Enum<typeof ExportStatuses>
